export const endpoints = {
  // Recognition Service
  list: () => '/dashboard/recognitions/',
  detail: code => `/dashboard/recognitions/${code}`,
  products: code => `/dashboard/recognitions/${code}/products`,
  spendingSummary: code => `/dashboard/recognitions/${code}/spending-summary`,
  acceptanceRate: code => `/dashboard/recognitions/${code}/acceptance-rate`,
  start: code => `/dashboard/recognitions/${code}/start`,
  popularGifts: '/dashboard/recognitions/popular-gifts',
  share: code => `/dashboard/recognitions/${code}/share-preview`,
  recipients: code => `/dashboard/recognitions/${code}/recipients`,
  orders: () => `/dashboard/orders`,
  order: code => `/dashboard/orders/${code}`,
  sendReminder: ({ code }) => `/dashboard/recognitions/${code}/reminders`,
  detailDuplicate: code => `/dashboard/recognitions/${code}/duplicate`,
  submitToApproval: code => `/dashboard/recognitions/${code}/send-for-approval`,

  recognition: () => '/dashboard/recognitions/',
  recognitionDetail: id => `/dashboard/recognitions/${id}`,
  recognitionSpendingSummary: id => `/dashboard/recognitions/${id}/spending-summary`,
  recognitionAcceptanceRate: id => `/dashboard/recognitions/${id}/acceptance-rate`,
  recognitionRecipientDetail: (id, orderId) => `/dashboard/recognitions/${id}/orders/${orderId}`,
  recognitionDetailStart: id => `/dashboard/recognitions/${id}/start`,
  recognitionDetailCancel: id => `/dashboard/recognitions/${id}/cancel`,
  recognitionSharePreview: code => `/dashboard/recognitions/${code}/share-preview`,

  recogRecipientsBulkUpsert: code => `/dashboard/recognitions/${code}/recipients/bulk-upsert`,
  recogRecipientsList: code => `/dashboard/recognitions/${code}/recipients`,
  recogRecipientsDelete: ({ code }) => {
    return `/dashboard/recognitions/${code}/recipients`;
  },
  recogLiveRecipientsDelete: ({ code, email }) => {
    return `/dashboard/recognitions/${code}/recipients/${email}`;
  },
  recognitionReachOutSupport: ({ code }) => {
    return `/dashboard/recognitions/${code}/reach-out-to-support`;
  },
  calculateEstimatedCharge: ({ code }) => {
    return `/dashboard/recognitions/${code}/calculate-estimated-charge`;
  },
  expireRecognition: ({ code }) => {
    return `/dashboard/recognitions/${code}/expire`;
  },
  goLiveFlags: code => {
    return `/dashboard/recognitions/${code}/go-live-checks`;
  }
};
